import { BasicModel } from "@goodgamestudios/core";

import { Poker2DialogEvent } from "../../event/Poker2DialogEvent";
import { Poker2Model } from "../../model/Poker2Model";
import { Poker2ProfilTabAchievement } from "../components/playerprofil/Poker2ProfilTabAchievement";
import { Poker2ProfilTabStats } from "../components/playerprofil/Poker2ProfilTabStats";
import { Poker2Dialog } from "./Poker2Dialog";
import { Poker2ProfilDialogProperties } from "./Poker2ProfilDialogProperties";

import { SFConstants } from "../../constants/SFConstants";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2ProfilDialog extends Poker2Dialog {
    public static NAME: string = "Poker2ProfilDialog";

    private tabAchievement: Poker2ProfilTabAchievement;
    private tabStats: Poker2ProfilTabStats;

    constructor(disp: Container) {
        super(disp);
    }

    protected init(): void {
        super.init();
        this.tabAchievement = new Poker2ProfilTabAchievement(this.profilDialog.mc_achievement);
        this.tabStats = new Poker2ProfilTabStats(this.profilDialog.mc_statistics);
    }

    protected applyProperties(): void {
        super.applyProperties();
        this.profilDialog.btn_statistics.toolTipText = Poker2Model.languageData.getTextById("menu_btn_statistics");
        this.profilDialog.btn_achievement.toolTipText = Poker2Model.languageData.getTextById("menu_btn_achievements");

        this.tabStats.applyProperties();
        this.tabAchievement.applyProperties();

    }

    public show(): void {
        super.show();
        this.changeTab(this.profilProperties.tabIndex);
        this.tabAchievement.show();
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);

        switch (event.target) {
            case this.profilDialog.btn_close:
                this.hide();
                break;
            case this.profilDialog.btn_achievement:
                this.getAchievementStats();
                break;
            case this.profilDialog.btn_statistics:
                this.getUserStats();
                break;
            case this.profilDialog.mc_achievement.btn_up:
                this.tabAchievement.onClick(event);
                break;
            case this.profilDialog.mc_achievement.btn_down:
                this.tabAchievement.onClick(event);
                break;
        }
    }

    private getUserStats(): void {
        var paramObject: any = { id: this.profilProperties.playerId };
        BasicModel.smartfoxClient.sendMessage("gpp", [JSON.stringify(paramObject)]);
    }

    private getAchievementStats(): void {
        var paramObject: any = { id: this.profilProperties.playerId };
        BasicModel.smartfoxClient.sendMessage("ali", [JSON.stringify(paramObject)]);
    }

    public hide(): void {
        this.tabAchievement.hide();
        this.controller.dispatchEvent(new Poker2DialogEvent("menueselection", ["Poker2ProfilDialog" + "_" + 2, 0]));
        this.controller.dispatchEvent(new Poker2DialogEvent("menueselection", ["Poker2ProfilDialog" + "_" + 1, 0]));
        super.hide();
    }

    public destroy(): void {
        super.destroy();
        this.tabAchievement.destroy();
    }

    private changeTab(tabIndex: number): void {
        this.profilDialog.mc_statistics.visible = (tabIndex == 2);
        this.profilDialog.mc_achievement.visible = (tabIndex == 1);

        this.controller.dispatchEvent(new Poker2DialogEvent("menueselection", ["Poker2ProfilDialog" + "_" + 2, (tabIndex == 2) ? 1 : 0]));
        this.controller.dispatchEvent(new Poker2DialogEvent("menueselection", ["Poker2ProfilDialog" + "_" + 1, (tabIndex == 1 ? 1 : 0)]));

        if (tabIndex == 2) {
            this.profilDialog.btn_achievement.deselected();
            this.profilDialog.btn_statistics.selected();
            this.tabStats.fillPlayerStatistics(this.profilProperties.playerProfile, this.profilProperties.playerId);
        }
        else {
            this.profilDialog.btn_achievement.selected();
            this.profilDialog.btn_statistics.deselected();
            this.tabAchievement.changeAchievementPage(0);
        }
    }

    protected get profilProperties(): Poker2ProfilDialogProperties {
        return this.properties as Poker2ProfilDialogProperties;
    }

    protected get profilDialog(): Library.PokerInterface.PokerProfil {
        return this.disp as Library.PokerInterface.PokerProfil;
    }
}
